import { render, staticRenderFns } from "./passManage.vue?vue&type=template&id=3e3b4276&scoped=true"
import script from "./passManage.vue?vue&type=script&lang=js"
export * from "./passManage.vue?vue&type=script&lang=js"
import style0 from "./passManage.vue?vue&type=style&index=0&id=3e3b4276&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3b4276",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/drone/src/components/SvgIcon/index.vue').default})
